import { RouteRecordRaw } from 'vue-router'

const catalogManagerRoutes: RouteRecordRaw[] = [
  {
    path: 'Catalogs',
    name: 'Catalogs',
    component: () =>
      import('@/views/CatalogManager/Components/CatalogCardListing.vue'),
    meta: {
      title: 'Catalog Manager'
    }
  },
  {
    path: 'Catalogs/Edit/:id',
    name: 'EditCatalog',
    component: () =>
      import('@/views/CatalogManager/Components/CatalogCreation.vue'),
    meta: {
      title: 'Edit Catalog',
      bpSwitchFallback: 'Catalogs'
    },
    beforeEnter: async (to, from, next) => {
      next()
    }
  },
  {
    path: 'Catalogs/settings',
    name: 'DestinationCatalogSettings',
    component: () => import('./Components/DestinationCatalogSettings.vue'),
    meta: {
      title: 'Destination Catalogs Settings',
      requireAuth: true
    }
  },
  {
    path: 'Catalogs/:id',
    name: 'CatalogDetail',
    component: () =>
      import('@/views/CatalogManager/Components/CatalogDetailPage.vue'),
    meta: {
      title: 'Catalog Details',
      bpSwitchFallback: 'Catalogs'
    }
  }
]
export default catalogManagerRoutes
